export default __webpack_public_path__ + "static/media/feedback-service.4e6ee7af.svg";